import React, { useState, useRef, useEffect } from "react";
import { FaPause, FaPlay } from "react-icons/fa";
import { MdOutlineFullscreen } from "react-icons/md";
import ReactPlayer from "react-player";
import { classNames } from "src/helpers/mixins";
import screenfull from 'screenfull';  

type props = {
  videoUrl: string;
};
const CustomVideoPlayer: React.FC<props> = ({ videoUrl }) => {
  const [playing, setPlaying] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  const [progress, setProgress] = useState(0);
  const playerRef = useRef(null);
  const playerContainerRef = useRef(null); // Referencia al contenedor del reproductor

  const handlePlayPause = () => {
    setPlaying(!playing);
  };

  const handleFullscreen = () => {
    const playerContainer = playerContainerRef.current;
    if (document.fullscreenElement) {
      setIsFullScreen(false);
      document.exitFullscreen();
    } else {
      if (playerContainer) {
        //@ts-ignore
        playerContainer.requestFullscreen();
        setIsFullScreen(true);
      }
    }
  };

  const handleProgressChange = (e: any) => {
    const newProgress = parseFloat(e.target.value);
    setProgress(newProgress);
    if (playerRef !== null) {
      //@ts-ignore
      playerRef.current.seekTo(newProgress);
    }
  };

  const handleProgress = (state: any) => {
    setProgress(state.played);
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(screenfull.isFullscreen);
      if (!screenfull.isFullscreen) {
        setIsFullScreen(false)
      }
    };

    if (screenfull.isEnabled) {
      screenfull.on('change', handleFullscreenChange);
    }

    return () => {
      if (screenfull.isEnabled) {
        screenfull.off('change', handleFullscreenChange);
      }
    };
  }, []);


  return (
    <div className="video-wrapper">
      <div className="custom-video-player" ref={playerContainerRef} tabIndex={0}>
        <ReactPlayer
          ref={playerRef}
          url={videoUrl}
          playing={playing}
          controls={false}
          width="100%"
          height={isFullScreen ? "90vh" : "55vh"}
          style={{
            background: "black",
            borderTopLeftRadius: "15px",
            borderTopRightRadius: "15px",
            marginBottom: "4rem",
          }}
          onProgress={handleProgress}
        />
        <div
          className={classNames(
            isFullScreen ? "controls-fullscreen" : "controls",
            "flex gap-3"
          )}
        >
          <button className="play-pause-button" onClick={handlePlayPause}>
            {playing ? <FaPause size={20} /> : <FaPlay size={20} />}
          </button>
          <input
            type="range"
            min={0}
            max={1}
            step={0.01}
            value={progress}
            onChange={handleProgressChange}
            className="progress-bar"
          />
          <button className="fullscreen-button" onClick={handleFullscreen}>
            <MdOutlineFullscreen size={30} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomVideoPlayer;
